"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API = exports.APISuccess = exports.APIError = exports.APIResponse = void 0;
class APIResponse {
    constructor({ data }) {
        this.data = data;
    }
}
exports.APIResponse = APIResponse;
class APIError extends APIResponse {
    constructor({ displayMessage, message }) {
        super({ data: null });
        this.error = {
            displayMessage: displayMessage,
            message: message
        };
        this.stack = new Error().stack;
    }
}
exports.APIError = APIError;
class APISuccess extends APIResponse {
    constructor({ displayMessage, data }) {
        super({ data: data });
        this.success = {
            data: data,
            displayMessage: displayMessage,
        };
    }
}
exports.APISuccess = APISuccess;
exports.API = {
    Error: APIError,
    Success: APISuccess,
    Response: APIResponse,
};
